/*eslint-disable */
var $ = window.jQuery = require('jquery')
import commentVideo from './comment-on-video-list';
import {
  mapGetters,
  } from 'vuex';
export default {
  name: 'vista-media-details',
  components: {
    'video-comments' : commentVideo
  },
  props: [],
  data() {
    return {
      popularVideosData:null,
      popularVideosResults:[],
      mediaVideoId:'',
      selectedVideoInfoByID:[]
    }
  },
  computed: {
    ...mapGetters([
      'getListVistaPrivateOfVideoGetters'
    ]),
    getVistaPublicMediaListFun(){
      return this.$store.getters.getListVistaPrivateOfVideoGetters.data;
    },
  },
  mounted () {
  },
  created(){
    this.mediaVideoId = this.$route.params.videoID
    this.getSelectedVideoInfoMethod(this.mediaVideoId)
  },
  methods: {
    getSelectedVideoInfoMethod(ID){
      this.$store.dispatch('getListVistaPrivateOfVideoFun').then((res) => {
        this.selectedVideoInfoByID = res.data.data.items.filter(media => media.snippet.resourceId.videoId === ID);
        return this.selectedVideoInfoByID;
      }).catch((err) => {

      })
    },
    getUnstyledItems(Media){
     let mediaList = Media.filter(item => item.snippet.thumbnails.default != undefined);
     return mediaList;
    }
  },
  watch:{
    getVistaPublicMediaListFun(newData, oldData){
      this.popularVideosData = newData
      this.popularVideosResults = this.popularVideosData.items 
    },
    '$route.params.videoID'(newId, oldId) {
      this.mediaVideoId = newId
      this.getSelectedVideoInfoMethod(newId)
    }
  },
}